import React from 'react';
import { Link } from 'react-router-dom';
// 🔥 Import statycznej mapy przystanków Gdyni/Trójmiasta
import FULL_STOP_MAP from '../data/FULL_STOP_MAP.js'; 


// Funkcja pomocnicza do tworzenia pełnej nazwy przystanku
const getFullStopName = (stop) => {
    const stopIdString = stop.stopId.toString();

    // 1. Sprawdzamy mapowanie dla stopId w statycznym pliku
    const mappedName = FULL_STOP_MAP[stopIdString];
    
    if (mappedName) {
        return mappedName; // Np. "Witomino Centrum 01"
    }

    // 2. Logika awaryjna (jeśli API Tristar ma subName)
    if (stop.subName) {
        return `${stop.stopDesc} ${stop.subName}`;
    }
    
    // 3. Ostatecznie używamy głównej nazwy
    return stop.stopDesc;
};


function StopsGrid({ currentStops, favoriteStops, toggleFavorite, userLocation, sortOrder, calculateDistance }) {
    if (!currentStops || currentStops.length === 0) {
      return <div>Nie znaleziono przystanków</div>;
    }

    return (
      <div className="stops-list">
        {currentStops.map(stop => {
          
          // 🔥 UŻYCIE POPRAWNEJ LOGIKI 🔥
          const fullStopName = getFullStopName(stop); 
          // ------------------------------------------

          const isFavorite = favoriteStops.includes(stop.stopId);

          return (
            <Link 
              to={`/stop/${stop.stopId}`} 
              key={stop.stopId} 
              className={`stop-item ${isFavorite ? 'favorite-stop' : ''}`}
            >
              <div className="stop-info">
                <div className="stop-name">{fullStopName}</div> {/* Użycie nazwy z mapowania */}
                <div className="stop-code">Kod: {stop.stopId}</div>
                {userLocation && sortOrder === 'distance' && (
                  <div className="stop-distance">
                    {calculateDistance(
                      userLocation.latitude,
                      userLocation.longitude,
                      stop.stopLat,
                      stop.stopLon
                    ).toFixed(1)} km od Ciebie
                  </div>
                )}
              </div>
              <div 
                className="favorite-icon" 
                onClick={(e) => toggleFavorite(e, stop.stopId)}
              >
                {isFavorite ? <span className="heart-filled">♥</span> : <span className="heart-empty">♡</span>}
              </div>
            </Link>
          );
        })}
      </div>
    );
  }

export default StopsGrid;